import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-5 d-block brz-aktiv" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "f-20"
}
const _hoisted_5 = {
  key: 1,
  class: "f-20"
}
const _hoisted_6 = {
  key: 0,
  class: "col-12 d-flex justify-content-end"
}
const _hoisted_7 = {
  key: 1,
  class: "col-12 d-flex justify-content-end"
}
const _hoisted_8 = { class: "mb-5 anwendungsliste d-block" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "list-group list-unstyled" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = ["href", "title"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "list-group-item mb-0" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "form-check mr-3" }
const _hoisted_21 = ["checked", "id", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.changeable)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.textStandard), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.textEdit), 1))
            ]),
            (_ctx.changeable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn btn-link mr-3",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelList()))
                  }, "Abbrechen"),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-anwendungen",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveList()))
                  }, "Änderungen speichern")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-anwendungen",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changechange && _ctx.changechange(...args)))
                  }, "Anwendungsfavoriten bearbeiten")
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.changeable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list-group-item mb-0",
                          key: item.uri
                        }, [
                          _createElementVNode("template", {
                            innerHTML: _ctx.getOriginalOpenWindowString(item)
                          }, null, 8, _hoisted_13),
                          (item.window && item.id && (item.id === 'OCT' || item.id === 'OCP'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.openWindow(item)), ["prevent"]),
                                class: "d-flex align-items-center fs-16",
                                title: _ctx.getTooltip(item),
                                rel: "noreferrer noopener"
                              }, [
                                _createElementVNode("div", null, _toDisplayString(item.displayName), 1),
                                _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                                  _createElementVNode("i", { class: "fas fa-external-link-alt ml-2 fs-12" }),
                                  _createElementVNode("span", { class: "sr-only" }, "öffnen")
                                ], -1))
                              ], 8, _hoisted_14))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _ctx.sanitizeUrl(item.uri),
                                class: "d-flex align-items-center fs-16",
                                title: _ctx.getTooltip(item),
                                target: "_blank",
                                rel: "noreferrer noopener"
                              }, [
                                _createElementVNode("div", null, _toDisplayString(item.displayName), 1),
                                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                                  _createElementVNode("i", { class: "fas fa-external-link-alt ml-2 fs-12" }),
                                  _createElementVNode("span", { class: "sr-only" }, "öffnen")
                                ], -1))
                              ], 8, _hoisted_15))
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_draggable, _mergeProps({
                      tag: "ul",
                      list: _ctx.list,
                      class: "list-group list-unstyled",
                      handle: ".handle"
                    }, _ctx.dragOptions, {
                      onStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag = true)),
                      onEnd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drag = false)),
                      "item-key": "name"
                    }), {
                      item: _withCtx(({ element, index }) => [
                        _createElementVNode("li", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _cache[8] || (_cache[8] = _createElementVNode("i", {
                                class: "fas fa-grip-horizontal handle mr-3",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  checked: element.favorit,
                                  id: index,
                                  onChange: ($event: any) => (_ctx.changeFavCheckbox(index))
                                }, null, 40, _hoisted_21),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: index
                                }, [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(element.displayName), 1),
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "als Favoriten einrichten", -1))
                                ], 8, _hoisted_22)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-arrow py-0 fs-12",
                                    onClick: ($event: any) => (_ctx.moveUp(index))
                                  }, [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "fas fa-long-arrow-alt-up" }, null, -1)
                                  ]))], 8, _hoisted_25))
                                : _createCommentVNode("", true),
                              (index < (_ctx.list.length -1))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn btn-arrow py-0 fs-12",
                                    onClick: ($event: any) => (_ctx.moveDown(index))
                                  }, [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("i", { class: "fas fa-long-arrow-alt-down" }, null, -1)
                                  ]))], 8, _hoisted_26))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 16, ["list"])
                  ]))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}